/**
 * The mark an expired session lands on onboarding with (`/onboarding?…&sessao=encerrada`).
 *
 * `GET /api/auth/logout?expired=1` deletes the session cookie and sends the person to onboarding.
 * Onboarding, on its own, sends anyone holding a well-formed customer cookie straight on to `next`
 * without asking the backend — so if that deletion did not take (a client that ignores
 * `Set-Cookie`, a webview, a concurrent request renewing the cookie), the two would bounce
 * between each other forever. With the mark, onboarding always shows the login: the landing of
 * an ended session is a one-way door, whether or not the cookie is gone, and it costs no backend
 * read.
 */
export const SESSION_ENDED_PARAM = "sessao";
export const SESSION_ENDED_VALUE = "encerrada";

/** Whether the address says the session that brought the person here has ended. */
export function isSessionEnded(params: Record<string, string | string[] | undefined>): boolean {
  const value = params[SESSION_ENDED_PARAM];

  return (Array.isArray(value) ? value[0] : value) === SESSION_ENDED_VALUE;
}
